import { Box, TextField, Typography } from "@mui/material"
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { GetExtraWorkAgreementQueryResponse } from "api/generatedApi";
import { Control, Controller, UseFormGetValues, UseFormRegister, UseFormSetValue } from "react-hook-form";
import { ExtraWorkAgreementFormData } from "../hooks/use-input-validation";
import { useTranslation } from "react-i18next";

export interface Props {
  disabled: boolean;
  control: Control<ExtraWorkAgreementFormData>;
}

export const DescriptionCard = (props: Props) => {
  const { disabled, control } = props;
  const { t } = useTranslation();
  return (
    <Box sx={{
      display: "flex",
      flexDirection: "row",
      gap: 1,
    }}>


      <Controller
        name="description"
        control={control}
        render={({ field }) => (          
            <TextField
              {...field}
              fullWidth
              multiline
              minRows={3}
              maxRows={8}
              disabled={disabled}
              variant="standard"
              placeholder={t("dashboard.extraWorkAgreements.create.placeholderDescription")}
              value={field.value || ""}
              InputProps={{
                disableUnderline: true,
              }}
              sx={{
                whiteSpace: "pre-wrap",
                overflowWrap: "break-word",
              }}
            />        
        )}
      />
    </Box>
  )
}

